(function () {
  'use strict';

  // Guard: the [data-recharge-redesign] marker is injected by Liquid only when
  // the "Enable Recharge widget redesign" block setting is checked.
  // If the marker is absent the script exits immediately with no side effects.
  if (!document.querySelector('[data-recharge-redesign]')) return;

  // ── Placeholder benefit copy — update these strings in the JS to finalise ──
  var BENEFITS = [
    'Free delivery every order',
    'Pause or cancel any time',
    'Save on every delivery',
    'Priority customer support',
    'Auto-refill — never run out',
    'Flexible delivery schedule'
  ];

  // ── Helpers ──

  function getText(el) {
    return el ? el.textContent.trim() : '';
  }

  // Inject fn() only if no child with className exists in parent yet.
  function once(parent, className, fn) {
    if (!parent.querySelector('.' + className)) fn();
  }

  // ── Core redesign function ──

  function applyRedesign() {
    var widget = document.querySelector('.recharge-subscription-widget .rc-widget');
    if (!widget) return;

    var options = widget.querySelector('.rc-radio-group__options');
    if (!options) return;

    // nth-child(2) = Subscribe & save  |  nth-child(1) = One-time purchase
    var subCard = options.querySelector('.rc-radio:nth-child(2)');
    var otCard  = options.querySelector('.rc-radio:nth-child(1)');
    if (!subCard || !otCard) return;

    // Activates all redesign CSS rules
    widget.classList.add('rc-redesign');

    // ────────────────────────────────────────────────
    // Subscribe card
    // ────────────────────────────────────────────────

    var discountLabelEl = subCard.querySelector('.discount-label');
    var subPriceEl      = subCard.querySelector('.price-label');
    var otPriceEl       = otCard.querySelector('.price-label');

    // Badge: extract percentage from discount text, e.g. "Subscribe & save 15%" → "15% OFF"
    var discountText = getText(discountLabelEl);
    var pctMatch     = discountText.match(/(\d+\s*%)/);
    var badgeText    = pctMatch ? pctMatch[1] + ' OFF' : (discountText || 'Subscribe & Save');

    // Heading: plan name before the percentage, e.g. "Subscribe & save"
    var headingText = discountText.replace(/\s*\d+\s*%.*$/, '').trim() || 'Subscribe & Save';

    // 1. Badge (position: absolute — visually overlaps top border)
    once(subCard, 'rc-redesign-badge--sub', function () {
      var el = document.createElement('span');
      el.className = 'rc-redesign-badge rc-redesign-badge--sub';
      el.textContent = badgeText;
      subCard.prepend(el);
    });

    // 2. Centered uppercase heading (prepended after badge so it flows below it)
    once(subCard, 'rc-redesign-heading', function () {
      var el = document.createElement('span');
      el.className = 'rc-redesign-heading';
      el.textContent = headingText.toUpperCase();
      subCard.prepend(el);
    });

    // 3. Compare-at on subscribe = the one-time price (the undiscounted amount)
    var otPriceText = getText(otPriceEl);
    if (otPriceText && subPriceEl) {
      once(subCard, 'rc-redesign-compare--sub', function () {
        var s = document.createElement('s');
        s.className = 'rc-redesign-compare rc-redesign-compare--sub';
        s.textContent = otPriceText;
        subPriceEl.insertAdjacentElement('afterend', s);
      });
    }

    // 4. Two-column benefit list with placeholder copy
    once(subCard, 'rc-redesign-benefits', function () {
      var ul = document.createElement('ul');
      ul.className = 'rc-redesign-benefits';
      BENEFITS.forEach(function (line) {
        var li = document.createElement('li');
        li.textContent = line;
        ul.appendChild(li);
      });
      subCard.appendChild(ul);
    });

    // ────────────────────────────────────────────────
    // One-time card
    // ────────────────────────────────────────────────

    // Badge: labelled "One-time" using the softer green
    once(otCard, 'rc-redesign-badge--ot', function () {
      var el = document.createElement('span');
      el.className = 'rc-redesign-badge rc-redesign-badge--ot';
      el.textContent = 'One-time';
      otCard.prepend(el);
    });

    // Compare-at on one-time = variant compare_at_price rendered by the theme
    // The theme outputs this into [data-compare-price]; only inject when it has content.
    once(otCard, 'rc-redesign-compare--ot', function () {
      var compareEl  = document.querySelector('[data-compare-price]');
      var compareText = compareEl ? compareEl.textContent.trim() : '';
      if (!compareText) return;
      var otPEl = otCard.querySelector('.price-label');
      if (!otPEl) return;
      var s = document.createElement('s');
      s.className = 'rc-redesign-compare rc-redesign-compare--ot';
      s.textContent = compareText;
      otPEl.insertAdjacentElement('afterend', s);
    });
  }

  // ── Initialisation ──

  function init() {
    applyRedesign();

    // MutationObserver: catch Recharge's async widget render.
    // Coalesce each burst of mutations into a single re-skin on the next animation
    // frame (~16ms) instead of an 80ms timeout, so the widget re-decorates almost
    // immediately after a frequency change. once()-guards keep it idempotent, and
    // any mutations mid-frame just schedule the next frame.
    var watchRoot = document.getElementById('recharge-widget')
                 || document.querySelector('.recharge-subscription-widget');
    if (watchRoot) {
      var rafScheduled = false;
      var mo = new MutationObserver(function () {
        if (rafScheduled) return;
        rafScheduled = true;
        (window.requestAnimationFrame || function (fn) { return setTimeout(fn, 16); })(function () {
          rafScheduled = false;
          applyRedesign();
        });
      });
      mo.observe(watchRoot, { childList: true, subtree: true });
    }

    // Polling fallback: retries for ~12 s then stops
    var ticks = 0;
    var poll  = setInterval(function () {
      applyRedesign();
      if (++ticks >= 40) clearInterval(poll);
    }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
